import axios from '../../utils/axios2';
import queryString from '../../utils/queryString';
export default {

    namespaced: true,

    state: {
        jobcard: null,
        jobcards: null
    },

    mutations: {
        setJobcard(state, payload) {
            state.jobcard = payload;
        },
        setJobcards(state, payload) {
            state.jobcards = payload;
        }
    },

    actions: {
        fetchJobcards({commit, rootState}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcards?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setJobcards', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        fetchJobcard({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcards/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setJobcard', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },
        storeJobcard({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `jobcards`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        updateJobcard({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcards/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });
        },
        removeJobcard({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `jobcards/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        jobcardFinalClose({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcards/${payload}/final-close`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        },
        jobcardReopen({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcards/${payload}/reopen`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
            });
        }
    }
}